import { type BasicCheckMerchantsResponse } from '@redteclab/api/clients/bully'

export const nowBasicCheckResponseAccessorIsCurrentVariantEligibleForDelivery =
  (response: BasicCheckMerchantsResponse | undefined): boolean => {
    if (!response) {
      return false
    }

    return Boolean(response.nowEligible && response.zipCodeInDeliveryRegion)
  }
